import { __assign, __rest } from "tslib";
import React from 'react';
import Select, { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import { VirtualMenuList } from './VritualMenuList';
import { CustomOption } from './CustomOption';
import { CustomDropdownIndicator } from './CustomDropdownIndicator';
import { CustomClearIndicator } from './CustomClearIndicator';
import { CustomInput } from './CustomInput';
import { CustomSingleValue } from './CustomSingleValue';
import { CustomMultiValueLabel } from './CustomMultiValueLabel';
export var Dropdown = function (_a) {
    var _b = _a.invalid, invalid = _b === void 0 ? false : _b, _c = _a.sizeToEnterVirtualization, sizeToEnterVirtualization = _c === void 0 ? 100 : _c, _d = _a.name, name = _d === void 0 ? '' : _d, _e = _a.styles, styles = _e === void 0 ? {} : _e, innerPropsOfValueTag = _a.innerPropsOfValueTag, isAsync = _a.isAsync, restProps = __rest(_a, ["invalid", "sizeToEnterVirtualization", "name", "styles", "innerPropsOfValueTag", "isAsync"]);
    var optionsLength = React.useMemo(function () { var _a; return (_a = restProps.options) === null || _a === void 0 ? void 0 : _a.length; }, [restProps.options]);
    var isWindowed = (optionsLength || 0) >= sizeToEnterVirtualization;
    var customComponents = {
        Option: CustomOption,
        DropdownIndicator: CustomDropdownIndicator,
        ClearIndicator: CustomClearIndicator,
        Input: CustomInput,
        MultiValueLabel: CustomMultiValueLabel,
        SingleValue: CustomSingleValue,
    };
    var customStyles = __assign(__assign({}, styles), { control: function (provided, state) {
            var borderColor = 'var(--alto)';
            if (state.isFocused) {
                borderColor = 'var(--cerulean)';
            }
            if (invalid) {
                borderColor = 'var(--well-read)';
            }
            var additionalPassedStyles = {};
            if (styles.control) {
                additionalPassedStyles = styles.control(provided, state);
            }
            return __assign(__assign(__assign({}, provided), additionalPassedStyles), { minHeight: '3rem', borderRadius: '0.5rem', borderColor: borderColor, boxShadow: 'unset', '&:hover': {
                    borderColor: 'var(--cerulean)',
                } });
        }, placeholder: function (provided, state) {
            var additionalPassedStyles = {};
            if (styles.placeholder) {
                additionalPassedStyles = styles.placeholder(provided, state);
            }
            return __assign(__assign(__assign({}, provided), additionalPassedStyles), { color: 'var(--dove)' });
        }, menu: function (provided, state) {
            var additionalPassedStyles = {};
            if (styles.menu) {
                additionalPassedStyles = styles.menu(provided, state);
            }
            return __assign(__assign(__assign({}, provided), additionalPassedStyles), { marginTop: '1px', border: '1px solid var(--alto)', boxShadow: '0px 1px 4px 0px #72727226', borderRadius: '0.5rem' });
        }, indicatorSeparator: function (provided, state) {
            var additionalPassedStyles = {};
            if (styles.indicatorSeparator) {
                additionalPassedStyles = styles.indicatorSeparator(provided, state);
            }
            return __assign(__assign(__assign({}, provided), additionalPassedStyles), { display: 'none' });
        }, option: function (provided, state) {
            var additionalPassedStyles = {};
            if (styles.option) {
                additionalPassedStyles = styles.option(provided, state);
            }
            var backgroundColor;
            var color = 'default';
            var hoverStyle = {
                '&:hover': {
                    backgroundColor: 'var(--hover-grey)',
                    cursor: 'pointer',
                },
            };
            if (state.isFocused) {
                backgroundColor = 'var(--hover-grey)';
            }
            else if (state.isSelected) {
                backgroundColor = 'var(--snuff)';
                color = 'var(--mirage)';
            }
            if (state.isMulti) {
                backgroundColor = 'unset';
            }
            if (state.isDisabled) {
                color = 'var(--alto)';
                hoverStyle = {
                    '&:hover': {
                        backgroundColor: 'none',
                        cursor: 'unset',
                    },
                };
            }
            return __assign(__assign(__assign(__assign({}, provided), additionalPassedStyles), { backgroundColor: backgroundColor, color: color }), hoverStyle);
        } });
    if (isWindowed) {
        customComponents = __assign(__assign({}, customComponents), { MenuList: VirtualMenuList });
    }
    if (isAsync) {
        return (React.createElement(AsyncSelect, __assign({}, restProps, { styles: customStyles, closeMenuOnSelect: restProps.isMulti ? false : restProps.closeMenuOnSelect, hideSelectedOptions: restProps.isMulti ? false : restProps.hideSelectedOptions, 
            // @ts-ignore
            selectProps: { invalid: invalid, name: name, innerPropsOfValueTag: innerPropsOfValueTag }, components: __assign(__assign({}, components), customComponents) })));
    }
    return (React.createElement(Select, __assign({}, restProps, { styles: customStyles, closeMenuOnSelect: restProps.isMulti ? false : restProps.closeMenuOnSelect, hideSelectedOptions: restProps.isMulti ? false : restProps.hideSelectedOptions, 
        // @ts-ignore
        selectProps: { invalid: invalid, name: name, innerPropsOfValueTag: innerPropsOfValueTag }, components: __assign(__assign({}, components), customComponents) })));
};
